// extracted by mini-css-extract-plugin
export default {"container":"DashboardToolbar_container__ZYVuP"};